module.exports = __webpack_public_path__ + "static/img/jiaoxue1.5cce1796.webp";